import React from 'react'
import { DiversityFilterPanelSkeleton } from '@diversioteam/diversio-ds'

export const FilterPaneSkeleton = () => {
    return <DiversityFilterPanelSkeleton />
}
